import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, forkJoin } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as moment from 'moment';
import * as i3 from 'primeng/dropdown';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/inputnumber';
import * as i6 from 'primeng/calendar';
import { PrimengLibraryModule } from 'primeng-library';

class CustomPeriodSelectionService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getperiodType() {
        var encryptedText = this.toEncrypt('FB_ONB_PAYROLL_PAY_PERIOD');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getPayScedule() {
        var encryptedText = this.toEncrypt('FBWEEKDAYNAME');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCurrencyCode() {
        var encryptedText = this.toEncrypt('FB_HIRING_CURRENCY');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getethnicity() {
        var encryptedText = this.toEncrypt('FB_ONB_PAYROLL_ETHNICITY');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getPayType() {
        var encryptedText = this.toEncrypt('FB_ONB_PAYROLL_PAY_TYPE');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
CustomPeriodSelectionService.ɵfac = function CustomPeriodSelectionService_Factory(t) { return new (t || CustomPeriodSelectionService)(i0.ɵɵinject(i1.HttpClient)); };
CustomPeriodSelectionService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomPeriodSelectionService, factory: CustomPeriodSelectionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomPeriodSelectionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomPeriodSelectionComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 16);
    i0.ɵɵtext(3, "Pay Day");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 17);
    i0.ɵɵlistener("onChange", function CustomPeriodSelectionComponent_ng_container_6_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.daysChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r0.payDayDetails);
} }
function CustomPeriodSelectionComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 18);
    i0.ɵɵtext(3, "Pay Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p-calendar", 19);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_7_Template_p_calendar_onSelect_5_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.monthlyDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
} }
function CustomPeriodSelectionComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 20);
    i0.ɵɵtext(3, "Pay Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p-calendar", 21);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_8_Template_p_calendar_onSelect_5_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.yearlyDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
} }
function CustomPeriodSelectionComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 22);
    i0.ɵɵtext(3, "Half Yearly Pay Date I");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p-calendar", 23);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_9_Template_p_calendar_onSelect_5_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.halfYearFirstDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelementStart(7, "label", 24);
    i0.ɵɵtext(8, "Half Yearly Pay Date II");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "p-calendar", 25);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_9_Template_p_calendar_onSelect_10_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.halfYearSecondDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
} }
function CustomPeriodSelectionComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 26);
    i0.ɵɵtext(3, "Half Monthly Pay Date I");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p-calendar", 27);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_10_Template_p_calendar_onSelect_5_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.halfMonthlyFirstDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelementStart(7, "label", 28);
    i0.ɵɵtext(8, "Half Monthly Pay Date II");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "p-calendar", 29);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_10_Template_p_calendar_onSelect_10_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.halfMonthlySecondDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
} }
function CustomPeriodSelectionComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 31);
    i0.ɵɵelementStart(3, "label", 32);
    i0.ɵɵtext(4, "Quarterly Pay Date I");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "p-calendar", 33);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_11_Template_p_calendar_onSelect_6_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.firstQuarterDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 34);
    i0.ɵɵelementStart(8, "label", 35);
    i0.ɵɵtext(9, "Quarterly Pay Date II");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵelementStart(11, "p-calendar", 36);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_11_Template_p_calendar_onSelect_11_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.secondQuarterDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 34);
    i0.ɵɵelementStart(13, "label", 37);
    i0.ɵɵtext(14, "Quarterly Pay Date III");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "br");
    i0.ɵɵelementStart(16, "p-calendar", 38);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_11_Template_p_calendar_onSelect_16_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.thirdQuarterDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 34);
    i0.ɵɵelementStart(18, "label", 39);
    i0.ɵɵtext(19, "Quarterly Pay Date IV");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "br");
    i0.ɵɵelementStart(21, "p-calendar", 40);
    i0.ɵɵlistener("onSelect", function CustomPeriodSelectionComponent_ng_container_11_Template_p_calendar_onSelect_21_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.fourthQuarterDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
} }
class CustomPeriodSelectionComponent {
    constructor(customPeriodSelectionService) {
        this.customPeriodSelectionService = customPeriodSelectionService;
        this.group = new FormGroup({});
        this.payPeriodTypeDetails = [];
        this.payDayDetails = [];
        this.ethnicityDetails = [];
        this.getCurrency = [];
        this.getPayType = [];
        this.weekly = false;
        this.monthly = false;
        this.quarterly = false;
        this.halfyearly = false;
        this.halfmonthly = false;
        this.yearly = false;
    }
    ngOnInit() {
        this.group.addControl(this.inputParams.name, new FormGroup({
            payPeriodType: new FormControl(),
            payPeriod: new FormControl(),
            payDay: new FormControl(),
            payday: new FormControl(),
            monthlyDate: new FormControl(),
            yearlyDate: new FormControl(),
            halfYearFirstDate: new FormControl(),
            halfYearSecondDate: new FormControl(),
            halfMonthlyFirstDate: new FormControl(),
            halfMonthlySecondDate: new FormControl(),
            firstQuarterDate: new FormControl(),
            secondQuarterDate: new FormControl(),
            thirdQuarterDate: new FormControl(),
            fourthQuarterDate: new FormControl(),
            payRate: new FormControl(),
            payType: new FormControl(),
            currency: new FormControl(),
            ethnicity: new FormControl(),
        }));
        this.compensationForm = (this.group.controls[this.inputParams.name]);
        this.getCompensationDetails();
    }
    getCompensationDetails() {
        const getperiodType = this.customPeriodSelectionService.getperiodType();
        const getPayScedule = this.customPeriodSelectionService.getPayScedule();
        const getethnicity = this.customPeriodSelectionService.getethnicity();
        const getCurrencyCode = this.customPeriodSelectionService.getCurrencyCode();
        const getPayType = this.customPeriodSelectionService.getPayType();
        this.forkJoinSubscription = forkJoin([
            getperiodType,
            getPayScedule,
            getethnicity,
            getCurrencyCode,
            getPayType
        ]).subscribe(([response1, response2, response3, response4, response5]) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            this.payPeriodTypeDetails = response1.data || null;
            this.payDayDetails = response2.data || null;
            this.ethnicityDetails = response3.data || null;
            this.getCurrency = response4.data || null;
            this.getPayType = response5.data || null;
            this.compensationForm.controls["payday"].setValue(((_a = this.inputParams.value) === null || _a === void 0 ? void 0 : _a.payday) ? this.inputParams.value.payday : null);
            this.compensationForm.controls["monthlyDate"].setValue(((_b = this.inputParams.value) === null || _b === void 0 ? void 0 : _b.monthlyDate) ? this.inputParams.value.monthlyDate : null);
            this.compensationForm.controls["yearlyDate"].setValue(((_c = this.inputParams.value) === null || _c === void 0 ? void 0 : _c.yearlyDate) ? this.inputParams.value.yearlyDate : null);
            this.compensationForm.controls["halfYearFirstDate"].setValue(((_d = this.inputParams.value) === null || _d === void 0 ? void 0 : _d.halfYearFirstDate) ? this.inputParams.value.halfYearFirstDate : null);
            this.compensationForm.controls["halfYearSecondDate"].setValue(((_e = this.inputParams.value) === null || _e === void 0 ? void 0 : _e.halfYearSecondDate) ? this.inputParams.value.halfYearSecondDate : null);
            this.compensationForm.controls["halfMonthlyFirstDate"].setValue(((_f = this.inputParams.value) === null || _f === void 0 ? void 0 : _f.halfMonthlyFirstDate) ? this.inputParams.value.halfMonthlyFirstDate : null);
            this.compensationForm.controls["halfMonthlySecondDate"].setValue(((_g = this.inputParams.value) === null || _g === void 0 ? void 0 : _g.halfMonthlySecondDate) ? this.inputParams.value.halfMonthlySecondDate : null);
            this.compensationForm.controls["firstQuarterDate"].setValue(((_h = this.inputParams.value) === null || _h === void 0 ? void 0 : _h.firstQuarterDate) ? this.inputParams.value.firstQuarterDate : null);
            this.compensationForm.controls["secondQuarterDate"].setValue(((_j = this.inputParams.value) === null || _j === void 0 ? void 0 : _j.secondQuarterDate) ? this.inputParams.value.secondQuarterDate : null);
            this.compensationForm.controls["thirdQuarterDate"].setValue(((_k = this.inputParams.value) === null || _k === void 0 ? void 0 : _k.thirdQuarterDate) ? this.inputParams.value.thirdQuarterDate : null);
            this.compensationForm.controls["fourthQuarterDate"].setValue(((_l = this.inputParams.value) === null || _l === void 0 ? void 0 : _l.fourthQuarterDate) ? this.inputParams.value.fourthQuarterDate : null);
            this.compensationForm.controls["payRate"].setValue(((_m = this.inputParams.value) === null || _m === void 0 ? void 0 : _m.payRate) ? this.inputParams.value.payRate : null);
            this.compensationForm.controls["payType"].setValue(((_o = this.inputParams.value) === null || _o === void 0 ? void 0 : _o.payType) ? this.inputParams.value.payType : null);
            this.compensationForm.controls["currency"].setValue(((_p = this.inputParams.value) === null || _p === void 0 ? void 0 : _p.currency) ? this.inputParams.value.currency : null);
            this.compensationForm.controls["ethnicity"].setValue(((_q = this.inputParams.value) === null || _q === void 0 ? void 0 : _q.ethnicity) ? this.inputParams.value.ethnicity : null);
            if ((_r = this.inputParams) === null || _r === void 0 ? void 0 : _r.value) {
                const getPayType = this.inputParams.value.payPeriodType[0];
                this.payPeriodChange(getPayType);
            }
        });
    }
    payPeriodChange(data) {
        if (data.value) {
            this.compensationForm.controls["payday"].setValue(null);
            this.compensationForm.controls["monthlyDate"].setValue(null);
            this.compensationForm.controls["yearlyDate"].setValue(null);
            this.compensationForm.controls["halfYearFirstDate"].setValue(null);
            this.compensationForm.controls["halfYearSecondDate"].setValue(null);
            this.compensationForm.controls["halfMonthlyFirstDate"].setValue(null);
            this.compensationForm.controls["halfMonthlySecondDate"].setValue(null);
            this.compensationForm.controls["firstQuarterDate"].setValue(null);
            this.compensationForm.controls["secondQuarterDate"].setValue(null);
            this.compensationForm.controls["thirdQuarterDate"].setValue(null);
            this.compensationForm.controls["fourthQuarterDate"].setValue(null);
        }
        this.compensationForm.controls["payPeriod"].setValue(data.value ? data.value : data.id);
        let type = this.payPeriodTypeDetails.filter((x) => x.id == (data.value ? data.value : data.id));
        this.group.controls[this.inputParams.name].patchValue({
            payPeriodType: type,
        });
        switch (type[0].name.toLowerCase().replace(" ", "")) {
            case "weekly":
                this.weekly = true;
                this.monthly = false;
                this.halfyearly = false;
                this.halfmonthly = false;
                this.quarterly = false;
                this.yearly = false;
                break;
            case "monthly":
                this.weekly = false;
                this.monthly = true;
                this.halfyearly = false;
                this.halfmonthly = false;
                this.quarterly = false;
                this.yearly = false;
                break;
            case "quarterly":
                this.weekly = false;
                this.monthly = false;
                this.halfyearly = false;
                this.halfmonthly = false;
                this.quarterly = true;
                this.yearly = false;
                break;
            case "halfyearly":
                this.weekly = false;
                this.monthly = false;
                this.halfyearly = true;
                this.halfmonthly = false;
                this.quarterly = false;
                this.yearly = false;
                break;
            case "halfmonthly":
                this.weekly = false;
                this.monthly = false;
                this.halfyearly = false;
                this.halfmonthly = true;
                this.quarterly = false;
                this.yearly = false;
                break;
            case "yearly":
                this.weekly = false;
                this.monthly = false;
                this.halfyearly = false;
                this.halfmonthly = false;
                this.quarterly = false;
                this.yearly = true;
                break;
            default:
                this.weekly = false;
                this.monthly = false;
                this.halfyearly = false;
                this.halfmonthly = false;
                this.quarterly = false;
                this.yearly = false;
                break;
        }
    }
    daysChange(data) {
        this.compensationForm.controls["payday"].setValue(data.value);
    }
    monthlyDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            monthlyDate: setDate,
        });
    }
    yearlyDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            yearlyDate: setDate,
        });
    }
    halfYearFirstDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            halfYearFirstDate: setDate,
        });
    }
    halfYearSecondDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            halfYearSecondDate: setDate,
        });
    }
    halfMonthlyFirstDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            halfMonthlyFirstDate: setDate,
        });
    }
    halfMonthlySecondDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            halfMonthlySecondDate: setDate,
        });
    }
    firstQuarterDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            firstQuarterDate: setDate,
        });
    }
    secondQuarterDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            secondQuarterDate: setDate,
        });
    }
    thirdQuarterDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            thirdQuarterDate: setDate,
        });
    }
    fourthQuarterDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            fourthQuarterDate: setDate,
        });
    }
    currencyChange(data) {
        this.compensationForm.controls["currency"].setValue(data.value);
    }
    ethnicityChange(data) {
        this.compensationForm.controls["ethnicity"].setValue(data.value);
    }
    payTypeChange(data) {
        this.compensationForm.controls["payType"].setValue(data.value);
    }
    ngOnDestroy() {
        this.forkJoinSubscription.unsubscribe();
    }
}
CustomPeriodSelectionComponent.ɵfac = function CustomPeriodSelectionComponent_Factory(t) { return new (t || CustomPeriodSelectionComponent)(i0.ɵɵdirectiveInject(CustomPeriodSelectionService)); };
CustomPeriodSelectionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomPeriodSelectionComponent, selectors: [["custom-period-selection"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName" }, decls: 28, vars: 11, consts: [[1, "container-fluid", "p-0", "mt-2", "mb-2", "pb-3", "custom-period-selection", 3, "formGroup"], [1, "row"], [1, "col-4", "pl-0"], ["for", "payPeriod", 1, "create-task-label"], ["appendTo", "body", "name", "payPeriod", "placeholder", "Select Period", "formControlName", "payPeriod", "optionLabel", "name", "optionValue", "id", 1, "w-100", 3, "options", "onChange"], [4, "ngIf"], [1, "col-4"], [1, "col-4", "pl-0", "mt-2"], ["for", "currencyType", 1, "create-task-label", "d-block"], ["inputId", "integeronly", "formControlName", "payRate", "placeholder", "Enter Pay Rate", 1, "payrate"], ["appendTo", "body", "name", "currency", "placeholder", "Currency", "formControlName", "currency", "optionLabel", "name", "optionValue", "id", 1, "currency", 3, "options", "onChange"], [1, "col-4", "pt-4", "mt-3"], [1, "mb-0", "paytype", "pr-3"], ["appendTo", "body", "name", "payType", "placeholder", "Pay Type", "formControlName", "payType", "optionLabel", "name", "optionValue", "id", 3, "options", "onChange"], ["for", "ethnicity", 1, "create-task-label"], ["appendTo", "body", "name", "ethnicity", "placeholder", "Select ", "formControlName", "ethnicity", "optionLabel", "name", "optionValue", "id", 1, "w-100", 3, "options", "onChange"], ["for", "payday", 1, "create-task-label"], ["appendTo", "body", "name", "payday", "placeholder", "Select Day", "formControlName", "payday", "optionLabel", "name", "optionValue", "id", 1, "w-100", 3, "options", "onChange"], ["for", "monthlyDate", 1, "create-task-label"], ["id", "monthlyDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "monthlyDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "monthlyDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "yearlyDate", 1, "create-task-label"], ["id", "yearlyDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "yearlyDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "yearlyDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "halfYearFirstDate", 1, "create-task-label"], ["id", "halfYearFirstDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "halfYearFirstDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "halfYearFirstDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "halfYearSecondDate", 1, "create-task-label"], ["id", "halfYearSecondDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "halfYearSecondDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "halfYearSecondDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "halfMonthlyFirstDate", 1, "create-task-label"], ["id", "halfMonthlyFirstDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "halfMonthlyFirstDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "halfMonthlyFirstDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "halfMonthlySecondDate", 1, "create-task-label"], ["id", "halfMonthlySecondDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "halfMonthlySecondDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "halfMonthlySecondDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], [1, "row", "mt-2"], [1, "col-3", "pl-0"], ["for", "firstQuarterDate", 1, "create-task-label"], ["id", "firstQuarterDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "firstQuarterDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "firstQuarterDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], [1, "col-3"], ["for", "secondQuarterDate", 1, "create-task-label"], ["id", "secondQuarterDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "secondQuarterDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "secondQuarterDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "thirdQuarterDate", 1, "create-task-label"], ["id", "thirdQuarterDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "thirdQuarterDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "thirdQuarterDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "fourthQuarterDate", 1, "create-task-label"], ["id", "fourthQuarterDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "fourthQuarterDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "fourthQuarterDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"]], template: function CustomPeriodSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, "Pay Period");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p-dropdown", 4);
        i0.ɵɵlistener("onChange", function CustomPeriodSelectionComponent_Template_p_dropdown_onChange_5_listener($event) { return ctx.payPeriodChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, CustomPeriodSelectionComponent_ng_container_6_Template, 5, 1, "ng-container", 5);
        i0.ɵɵtemplate(7, CustomPeriodSelectionComponent_ng_container_7_Template, 6, 1, "ng-container", 5);
        i0.ɵɵtemplate(8, CustomPeriodSelectionComponent_ng_container_8_Template, 6, 1, "ng-container", 5);
        i0.ɵɵtemplate(9, CustomPeriodSelectionComponent_ng_container_9_Template, 11, 2, "ng-container", 5);
        i0.ɵɵtemplate(10, CustomPeriodSelectionComponent_ng_container_10_Template, 11, 2, "ng-container", 5);
        i0.ɵɵtemplate(11, CustomPeriodSelectionComponent_ng_container_11_Template, 22, 4, "ng-container", 5);
        i0.ɵɵelement(12, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 1);
        i0.ɵɵelementStart(14, "div", 7);
        i0.ɵɵelementStart(15, "label", 8);
        i0.ɵɵtext(16, "Pay Rate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "p-inputNumber", 9);
        i0.ɵɵelementStart(18, "p-dropdown", 10);
        i0.ɵɵlistener("onChange", function CustomPeriodSelectionComponent_Template_p_dropdown_onChange_18_listener($event) { return ctx.currencyChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 11);
        i0.ɵɵelementStart(20, "p", 12);
        i0.ɵɵtext(21, "Per");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "p-dropdown", 13);
        i0.ɵɵlistener("onChange", function CustomPeriodSelectionComponent_Template_p_dropdown_onChange_22_listener($event) { return ctx.payTypeChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 1);
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵelementStart(25, "label", 14);
        i0.ɵɵtext(26, "Ethnicity");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "p-dropdown", 15);
        i0.ɵɵlistener("onChange", function CustomPeriodSelectionComponent_Template_p_dropdown_onChange_27_listener($event) { return ctx.ethnicityChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.compensationForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.payPeriodTypeDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.weekly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.monthly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.yearly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.halfyearly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.halfmonthly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.quarterly);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("options", ctx.getCurrency);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.getPayType);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.ethnicityDetails);
    } }, directives: [i2.NgControlStatusGroup, i2.FormGroupDirective, i3.Dropdown, i2.NgControlStatus, i2.FormControlName, i4.NgIf, i5.InputNumber, i6.Calendar], styles: [".paytype[_ngcontent-%COMP%]{display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomPeriodSelectionComponent, [{
        type: Component,
        args: [{
                selector: "custom-period-selection",
                templateUrl: "custom-period-selection.component.html",
                styleUrls: ["custom-period-selection.component.scss"],
            }]
    }], function () { return [{ type: CustomPeriodSelectionService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class CustomPeriodSelectionModule {
}
CustomPeriodSelectionModule.ɵfac = function CustomPeriodSelectionModule_Factory(t) { return new (t || CustomPeriodSelectionModule)(); };
CustomPeriodSelectionModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomPeriodSelectionModule });
CustomPeriodSelectionModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomPeriodSelectionModule, { declarations: [CustomPeriodSelectionComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomPeriodSelectionComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomPeriodSelectionModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomPeriodSelectionComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomPeriodSelectionComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-period-selection
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomPeriodSelectionComponent, CustomPeriodSelectionModule, CustomPeriodSelectionService };
//# sourceMappingURL=custom-period-selection.js.map
